module.exports = __webpack_public_path__ + "img/涂宇欣.6b392057.jpg";